import axios from "axios"
import React, { Component } from "react"
import "./crs_consent.css"
import { isMobile } from "react-device-detect"
import BannerContentLeft from "../../components/BannerContentLeft/BannerContentLeft"
import Loading from "../../components/loading/loading"
import iScroll from "iscroll/build/iscroll-probe"
import ReactIScroll from "react-iscroll"
import { config } from "./../../constants"
import { popupErrorApi } from "../../components/helpers/Helpers"
 
 
class CrsConsent extends Component {
  constructor(props) {
    super(props)
 
    this.state = {
      loading: true,
      buttonEnabled: false,
      iScrollOptions: {
        bounce: false,
        probeType: 2,
        mouseWheelSpeed: 20,
        mouseWheel: true,
        scrollbars: true,
        interactiveScrollbars: true,
        fadeScrollbars: true,
        scrollY: true,
      },
      titleText: '',
      detailText: '',
      btnOkText: '',
    }
  }
 
  componentDidMount = async () => {
    await this.loadConsentText()
    await this.loadDataFromLocalStorage()
  }

  loadConsentText = async () => {
    await axios.get(config.baseURL + `/api/consent?id=crs`)
      .then(async (res) => {
        let data = res.data
        if (data && data.data.length > 0) {
          let row = data.data[0]
          await this.setState({
            loading: false,
            titleText: row.title,
            detailText: row.detail,
            btnOkText: row.okBtn,
          })
        } else {
          popupErrorApi("ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง", "เกิดข้อผิดพลาด", true)
        }
      })
      .catch(async (error) => {
        if (!!error.isAxiosError && !error.response) {
          title_mss = "เกิดข้อผิดพลาด"
          mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"
        } else {
          var mss = ""
          var title_mss = ""
          if (!!error.isAxiosError && !error.response) {
            title_mss = "เกิดข้อผิดพลาด"
            mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"
          } else {
            title_mss =
              error.response.data.Data[0][0].MsgDescTitle !== ""
                ? error.response.data.Data[0][0].MsgDescTitle
                : "เกิดข้อผิดพลาด"
            mss =
              error.response.data.Data[0][0].MsgDesc !== ""
                ? error.response.data.Data[0][0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"
          }
        }

        popupErrorApi(mss, title_mss, true)
      })

    await this.setState({buttonEnabled: false})
  }
 
  onScroll = async (iScrollInstance) => {
    if (!this.state.buttonEnabled && iScrollInstance.y <= iScrollInstance.maxScrollY) {
      await this.setState({ buttonEnabled: true })
    }
  }

  onScrollRefresh = async (iScrollInstance) => {
    if (!this.state.buttonEnabled && iScrollInstance.y <= iScrollInstance.maxScrollY) {
      await this.setState({ buttonEnabled: true })
    }
  }
 
  loadDataFromLocalStorage = async () => {
    let flag = localStorage.getItem('crs_consent')
    if (flag == 'true') {
      await this.setState({buttonEnabled: true})
    }
  }
 
  saveDataToLocalStorage = async () => {
    localStorage.setItem('crs_consent', 'true')
  }
 
  goBack = () => {
    this.props.history.push("crs_declare_location")
  }
 
  handleSubmit = async () => {
    this.saveDataToLocalStorage()
    this.props.history.push("otp?page=crs_consent")
  }
  
  render() {
    return (
      <div className={isMobile ? "" : "body"}>
        <header
          className={isMobile ? "" : "header-area"}
          style={{ display: isMobile ? "none" : "block" }}
        >
          <div className={"container everest-nav-container"}>
            <div className={"row"}>
              <div className={"col-md-6"}>
                <img src="../../../images/logo.png" />
              </div>
              <div className={"col-md-6 flex_end"}>
                <div className="text-branding">บริการเปิดบัญชีออนไลน์</div>
              </div>
            </div>
          </div>
        </header>
        <section
          className={isMobile ? "" : "desktop_content section-gap-full"}
          style={{
            backgroundImage: isMobile ? "none" : "url(/images/bg.jpg)",
          }}
        >
          <div className={isMobile ? "" : "container"}>
            <div className={isMobile ? "" : "row"}>
              <div
                className={"col-md-6"}
                style={{ display: isMobile ? "none" : "block" }}
              >
                <BannerContentLeft></BannerContentLeft>
              </div>
              <div className={isMobile ? "" : "col-md-6"}>
                {/* content mobile */}
                <div>
                  <div className="content">
                    <div className="top_main_back">
                      <div className="main_back" onClick={this.goBack}>
                        <img
                          src={
                            isMobile
                              ? "/images/angle-arrow-left.svg"
                              : "/images/angle-arrow-left-blue.svg"
                          }
                          alt="forward"
                          style={{ marginLeft: "3px" }}
                          className="arrow_back"
                        />
                      </div>
                      <div className="text_title">{this.state.titleText}</div>
                    </div>
                    <div className="bg_content_white" style={{ paddingTop: 0 }}>
                      <div
                        className="in_bg_white"
                        style={{ top: 0, bottom: 120, right: 0 }}
                      >
                        <ReactIScroll
                          iScroll={iScroll}
                          options={this.state.iScrollOptions}
                          onScroll={this.onScroll}
                          onRefresh={this.onScrollRefresh}
                        >
                          <div style={{paddingRight: '16px'}} dangerouslySetInnerHTML={{__html: this.state.detailText}}>
                            {/* <div className="title_row">การยืนยัน และการเปลี่ยนแปลงสถานะ</div>
                            <div className="consent_text">
                              ท่านยืนยันว่าข้อความข้างต้นเป็นความจริง ครบถ้วน ถูกต้องและเป็นปัจจุบัน<br/><br/>
                                1.&nbsp;&nbsp;ท่านรับทราบ และตกลงว่าหากข้อมูลที่ให้ตามแบบฟอร์มนี้ ข้อมูลอันเป็นเท็จ ไม่ถูกต้อง หรือไม่ครบถ้วนสมบูรณ์ กลุ่มธุรกิจการเงิน DAOL และ / หรือ DAOL พาร์ทเนอร์ มีสิทธิใช้  ดุลยพินิจแต่เพียงฝ่ายเดียวที่จะยุติความสัมพันธ์ทางการเงิน/ทางธุรกิจกับท่านไม่ว่าทั้งหมดหรือบางส่วน ตามที่กลุ่มธุรกิจการเงิน DAOLและ/หรือ DAOL พาร์ทเนอร์ เห็นสมควร <br/><br/>
                                2.&nbsp;&nbsp;ท่านตกลงที่จะแจ้งให้กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ ทราบ และนำส่งเอกสารประกอบให้แก่กลุ่มธุรกิจการเงิน DAOL และ DAOL พาร์ทเนอร์ ภายใน 30 วัน หลังจากมีเหตุการณ์เปลี่ยนแปลงอันทำให้ข้อมูลของท่านที่ระบุในแบบฟอร์มนี้ไม่ถูกต้อง ไม่ครบถ้วน หรือ ไม่เป็นปัจจุบัน<br/><br/>
                                3.&nbsp;&nbsp;ท่านรับทราบ และตกลงว่าในกรณีที่ท่านไม่ได้ดำเนินการตามข้อ 2 ข้างต้น หรือมีการนำส่งข้อมูลอันเป็นเท็จ ไม่ถูกต้อง หรือไม่ครบถ้วนสมบูรณ์ เกี่ยวกับสถานะของท่าน กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ มีสิทธิใช้ดุลยพินิจแต่เพียงฝ่ายเดียวที่จะยุติความสัมพันธ์ทางการเงิน / ทางธุรกิจกับท่าน ไม่ว่าทั้งหมดหรือบางส่วน ตามที่กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ เห็นสมควร
                            </div>
                            <div className="title_row">การเปิดเผยข้อมูล และความยินยอมในการหักเงินในบัญชี</div>
                            <div className="consent_text">
                              ท่านตกลงโดยไม่เพิกถอน ในการดำเนินการดังต่อไปนี้<br/><br/>
                              1.&nbsp;&nbsp;กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ จะเปิดเผยข้อมูลต่าง ๆ ของท่านให้แก่บริษัทภายในกลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ (รวมถึงนิติบุคคลที่เกี่ยวข้องของ DAOL พาร์ทเนอร์) เพื่อประโยชน์ในการปฏิบัติตาม FATCA / CRS / OECD หน่วยงานจัดเก็บภาษีอากรในประเทศ และ/หรือ ต่างประเทศ ซึ่งรวมถึง หน่วยงานจัดเก็บภาษีอากรของสหรัฐอเมริกา (Internal Revenue Service: IRS) ข้อมูลดังกล่าวรวมถึง ชื่อลูกค้า ที่อยู่ เลขประจำตัว ผู้เสียภาษี หมายเลขบัญชี สถานะตามหลักเกณฑ์เรื่อง FATCA (คือ เป็นผู้ปฏิบัติตาม หรือผู้ไม่ให้ความร่วมมือ) จำนวนเงินหรือมูลค่าคงเหลือในบัญชี การจ่ายเงินเข้า-ออกจากบัญชี รายการเคลื่อนไหวทางบัญชี จำนวนเงิน ประเภทและมูลค่าของผลิตภัณฑ์ทางการเงิน และ/หรือ ทรัพย์สินอื่น ๆ ที่มีอยู่กับกลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ ตลอดจนจำนวนรายได้ และข้อมูลอื่น ๆ ที่เกี่ยวกับความสัมพันธ์ทางการเงิน/ทางธุรกิจที่อาจถูกร้องขอโดยบริษัทภายในกลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ หน่วยงานทางภาษีอากรในประเทศ และ/หรือ ต่างประเทศ ซึ่งรวมถึง IRS ด้วย<br/><br/>
                              2.&nbsp;&nbsp;ท่านยินยอมให้กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ หักเงินจากบัญชีของท่าน และ/หรือ เงินได้ที่ท่านได้รับจากหรือผ่านกลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ ในจำนวนที่กำหนดโดยหน่วยงานจัดเก็บภาษีอากรในประเทศ และ/หรือต่างประเทศ ซึ่งรวมถึง IRS ภายใต้บังคับของกฎหมาย และ/หรือ กฎเกณฑ์ต่าง ๆ รวมถึงข้อตกลงใด ๆ ระหว่างกลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ กับหน่วยงานจัดเก็บภาษีอากรดังกล่าว<br/><br/>
                              3.&nbsp;&nbsp;หากท่านไม่ให้ข้อมูลที่จำเป็นต่อการพิจารณาสถานะความเป็นบุคคลอเมริกัน (U.S. person) สถานะผู้ถือบัญชีที่ต้องถูกรายงาน หรือข้อมูลที่จำเป็นต้องรายงานให้แก่กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ หรือไม่สามารถจะขอให้ยกเว้นการบังคับใช้กฎหมายที่ห้ามการรายงานข้อมูลได้ กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ มีสิทธิใช้ดุลยพินิจแต่เพียงฝ่ายเดียวที่จะยุติความสัมพันธ์ทางการเงิน/  ทางธุรกิจกับท่าน ไม่ว่าทั้งหมดหรือบางส่วน ตามที่กลุ่มธุรกิจการเงิน DAOL และ/หรือ DAOL พาร์ทเนอร์ เห็นสมควร
                            </div> */}
                          </div>
                        </ReactIScroll>
                      </div>
                      <div
                        className="under_fix_btn"
                        style={{ background: "#fff" }}
                      >
                        {!this.state.buttonEnabled && (
                          <div style={{textAlign: 'center', marginBottom: '10px'}}>เลื่อนลงเพื่ออ่านเพิ่มเติม</div>
                        )}
                        <button
                          className="crs_declare_location_form_next_btn"
                          onClick={this.handleSubmit}
                          style={!this.state.buttonEnabled ? {backgroundColor: '#e0e1e2', color: '#b0b0b0'} : {backgroundColor: '#003b66', color: 'white'}}
                          disabled={!this.state.buttonEnabled}
                        >{this.state.btnOkText}</button>
                      </div>
                    </div>
                  </div>
                  <Loading status={this.state.loading}></Loading>
                </div>
                {/* end content mobile */}
              </div>
            </div>
          </div>
          
        </section>
      </div>
    )
  }
}
export default CrsConsent
 
 